import dayjs from "dayjs";
import * as XLSX from "xlsx";

import type { SupplierInvoice } from "~/types/purchasing";

/** Document-type code → Spanish label (shared with SupplierInvoicesPage). */
export const TIPO_LABEL: Record<string, string> = {
  FE: "Factura",
  FNE: "Factura Exenta",
  FEX: "Factura Extranjera",
  DI: "Declaración de Ingreso (DI 914)",
  NC: "Nota de Crédito",
  NCEX: "Nota de Crédito extranjera",
};

/**
 * Export the (already filtered) supplier-invoice list to an .xlsx workbook.
 * Amounts are written as raw numbers so Excel treats them numerically.
 */
export function exportSupplierInvoicesToExcel(invoices: SupplierInvoice[]) {
  const rows = invoices.map((inv) => ({
    Proveedor: inv.supplier?.name ?? inv.razon_social ?? "",
    RUT: inv.rut ?? "",
    Tipo: TIPO_LABEL[inv.doc_tipo_code] ?? inv.doc_tipo_code,
    Folio: inv.folio,
    Emisión: inv.emission_date,
    Vencimiento: inv.due_date ?? "",
    Estado: inv.bsale_estado === "aceptado" ? "Aceptado" : "Recepcionado",
    "Neto (CLP)": Number(inv.neto),
    "IVA (CLP)": Number(inv.iva),
    "Exento (CLP)": Number(inv.exento),
    "Impuesto específico (CLP)": Number(inv.impto_especifico),
    "Total (CLP)": Number(inv.total_clp),
    Documento: inv.url_pdf ?? "",
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);
  ws["!cols"] = [
    { wch: 42 }, { wch: 14 }, { wch: 16 }, { wch: 12 }, { wch: 12 },
    { wch: 12 }, { wch: 14 }, { wch: 16 }, { wch: 14 }, { wch: 14 },
    { wch: 20 }, { wch: 16 }, { wch: 48 },
  ];
  XLSX.utils.book_append_sheet(wb, ws, "Facturas de Proveedor");
  XLSX.writeFile(wb, `Facturas_Proveedor_${dayjs().format("YYYY-MM-DD")}.xlsx`);
}
